import type { CustomCellRendererProps } from "ag-grid-react";
import pluralize from "pluralize";

import { extractValueAsArray } from "../utils/tables.ts";
import { TableCellWrapper } from "./TableCellWrapper.tsx";

/**
 * @Warning This cell is not implemented!
 *
 * Alignment cells are populated using genome/protein comparison tools.
 * However, the alignment display relies on expandable table rows, which we don't
 * have at the moment. Thus, we agreed to show a "Not Supported" string in case data has been
 * populated for a protein.
 *
 * @param props
 * @constructor
 */
export const BlastAlignmentCell = (props: CustomCellRendererProps) => {
  const values = extractValueAsArray(props.value);
  return (
    <TableCellWrapper {...props}>
      {values.length > 0 ? `${values.length} ${pluralize("alignment", values.length)}` : null}
    </TableCellWrapper>
  );
};
